import { put } from "../../utils/api";
import GenericViewDrawer1 from "./GenericViewDrawer1";
import DocumentItem from "../../Components/Masters/DocumentItem";

const RoadViewPage = ({
  open,
  onClose,
  data,
  setsnackOpen,
  fetchDataCallback,
  apiUrl,
}) => {
  if (!data) return null;

  const handleApprovalAction = async (action) => {
    try {
      const response = await put(`${apiUrl}/${data._id}`, {
        approvalStatus: action === "approve" ? "Accepted" : "Rejected",
      });
      if (response?.data) {
        setsnackOpen({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        fetchDataCallback();
        onClose();
      }
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error.message || "An error occurred",
        severity: "error",
      });
    }
  };

  const formatDate = (date) =>
    date ? new Date(date).toLocaleDateString("en-IN") : "—";

  const fields = [
    {
      label: "Trip Date",
      previous: formatDate(data?.tripDate),
      requested: formatDate(data?.editValue?.tripDate),
    },
    {
      label: "Associated Vendor",
      previous:
        data?.associatedVendor?.contactPersonName ||
        data?.associatedVendor?._id ||
        "—",
      requested:
        data?.editValue?.associatedVendorData?.contactPersonName ||
        data?.editValue?.associatedVendor ||
        "—",
    },
    {
      label: "Driver",
      previous: data?.driver?.driverName || data?.driver?._id || "—",
      requested:
        data?.editValue?.driverData?.driverName ||
        data?.editValue?.driver ||
        "—",
    },
    {
      label: "Vehicle",
      previous: data?.vehicle?.vehicleNumber || data?.vehicle?._id || "—",
      requested:
        data?.editValue?.vehicleData?.vehicleNumber ||
        data?.editValue?.vehicle ||
        "—",
    },

    {
      label: "Source",
      previous: data?.source || "—",
      requested: data?.editValue?.source || "—",
    },
    {
      label: "Destination",
      previous: data?.destination || "—",
      requested: data?.editValue?.destination || "—",
    },
    {
      label: "Transportation Type",
      previous: data?.transportationType || "—",
      requested: data?.editValue?.transportationType || "—",
    },
  ];

  return (
    <GenericViewDrawer1
      open={open}
      onClose={onClose}
      title="Road Transportation Entry Details"
      fields={fields}
      documentsField={{
        label: "Documents",
        previous: data?.documents,
        requested: data?.editValue?.documents,
      }}
      timeline={data?.timeLine}
      editRemarkReason={data?.editRemarkReason}
      onApprove={() => handleApprovalAction("approve")}
      onReject={() => handleApprovalAction("reject")}
      customDocumentRender={(url, i) => (
        <DocumentItem key={`doc-${i}`} url={url} />
      )}
    />
  );
};

export default RoadViewPage;
